import { useEffect, useRef, useState } from "react";
import { landingContent } from "../../data/landingContent";
import { SearchHandleForm } from "./SearchHandleForm";

/**
 * Sticky search bar that appears at the bottom of the screen
 * once the hero section scrolls out of view, and hides when
 * the final CTA enters view.
 */
export function StickySearchBar() {
  const [visible, setVisible] = useState(false);
  const heroObserverRef = useRef<IntersectionObserver | null>(null);
  const ctaObserverRef = useRef<IntersectionObserver | null>(null);
  const { hero } = landingContent;

  useEffect(() => {
    const heroEl = document.getElementById("top");
    const ctaEl = document.getElementById("final-cta");

    heroObserverRef.current = new IntersectionObserver(
      ([entry]) => {
        // Show bar when hero is NOT visible
        if (!entry.isIntersecting) {
          setVisible(true);
        } else {
          setVisible(false);
        }
      },
      { threshold: 0.1 }
    );

    if (heroEl) heroObserverRef.current.observe(heroEl);

    // Hide when final CTA is in view
    ctaObserverRef.current = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) setVisible(false);
      },
      { threshold: 0.2 }
    );

    if (ctaEl) ctaObserverRef.current.observe(ctaEl);

    return () => {
      heroObserverRef.current?.disconnect();
      ctaObserverRef.current?.disconnect();
    };
  }, []);

  return (
    <div className={`st-sticky-bar${visible ? " is-visible" : ""}`} role="complementary" aria-label="Quick search">
      <div className="st-search-wrapper" style={{ margin: "0 auto" }}>
        <SearchHandleForm
          placeholder={hero.inputPlaceholder}
          ctaLabel={hero.ctaLabel}
          typewriterExamples={[]}
        />
      </div>
    </div>
  );
}
